export const isPwa = window.matchMedia('(display-mode: standalone)').matches;
export const isWebkit = window.webkit && window.navigator && window.navigator.standalone;
export const isIosApp = window.webkit && window.webkit.messageHandlers && window.navigator && window.navigator.standalone;
export const isAndroidApp = document.referrer.includes('android-app://');
